export const businessEmailQuestions = [
  {
    id: 1,
    koreanQuestion:
      "나는 (현재) Martha의 매니저였습니다 델타 코프에서 ___하는 동안. 시니어 매니저로 ",
    question:
      "I have been Martha's manager while ______ for Delta Corp. as a Senior Manager.",
    choices: {
      A: "working",
      B: "worked",
      C: "work",
      D: "works",
    },
    correctAnswer: "A",
    explanation:
      "A: 일하는(현재분사) B: 일했던(과거형) C: 일하다(원형) D: 일한다(3인칭 단수) / 'while' 뒤에는 현재분사(~ing)가 와서 '~하는 동안'이라는 의미를 나타냅니다. 'while working'은 '일하는 동안'이라는 의미로 문맥상 가장 적절합니다.",
    translation:
      "저는 델타 코프에서 시니어 매니저로 근무하는 동안 마사의 관리자였습니다.",
    type: "business email",
  },
  {
    id: 2,
    koreanQuestion:
      "저는 (현재) 추천 중입니다 그녀를 장학프로그램을 위해서 제가 (현재) 목격했기때문에 그녀의 꿈을 되는것 전문적 데이터 분석가가",
    question:
      "I am recommending her for the scholarship program as I have witnessed ______ her dreams of becoming a professional Data Analyst.",
    choices: {
      A: "personally",
      B: "firsthand",
      C: "mostly",
      D: "increasingly",
    },
    correctAnswer: "B",
    explanation:
      "A: 개인적으로 B: 직접적으로 C: 대부분 D: 점점 더 / 'firsthand'는 '직접적으로, 직접 경험하여'라는 의미로, 화자가 그녀의 꿈을 직접 목격했다는 맥락에서 가장 적절한 표현입니다.",
    translation:
      "저는 그녀를 장학금 프로그램에 추천합니다. 제가 그녀의 데이터 분석가가 되고자 하는 꿈을 직접 목격했기 때문입니다.",
    type: "business email",
  },
  {
    id: 3,
    koreanQuestion:
      "Martha는 하나입니다  ______ 데이터 분석가 중에서 그... 우리팀에 있는 ",
    question:
      "Martha is one of the ______ Data Analysts that we have on our team.",
    choices: {
      A: "better",
      B: "best",
      C: "most",
      D: "good",
    },
    correctAnswer: "B",
    explanation:
      "A: 더 잘하는 B: 가장 뛰어난 C: 가장~ 한 D:좋은  즉, Martha가 가장 뛰어난 데이터 분석가라는 말을 하고싶은 것으로, 글의 목적을 알고 best를 고르면 됩니다.",
    translation: "마사는 우리 팀에서 가장 뛰어난 데이터 분석가 중 한 명입니다.",
    type: "business email",
  },
  {
    id: 4,
    koreanQuestion:
      "그녀는 ______  효과적인 실행 프로젝트 그.. (과거에)도왔던 회사가 절약하는데 시간 그리고 전체적 비용을",
    question:
      "She ______ the effective implementation of a project which helped the company save on time and overall savings.",
    choices: {
      A: "lead",
      B: "was led",
      C: "led",
      D: "leads to",
    },
    correctAnswer: "C",
    explanation:
      "A: 이끌다 B: 이끌어졌다 C: 이끌었다 D: ~로 이끌다 / 'led'는 'lead'의 과거형으로, 그녀가 과거에 프로젝트를 효과적으로 이끌었다는 의미입니다. 문맥상 과거 시제가 적절합니다.",
    translation:
      "그녀는 프로젝트의 효과적인 실행을 이끌어 회사가 시간과 전체적인 비용을 절약하는 데 도움을 주었습니다.",
    type: "business email",
  },
  {
    id: 5,
    koreanQuestion:
      "그녀의 기여는 결과이다 그.. 누군가 ______ 벗어난 틀에서 유지하면서도 표준과 프로세스를 ",
    question:
      "Her contributions are a result of someone ______ out of the box while maintaining standards and processes in check.",
    choices: {
      A: "thinking",
      B: "thought",
      C: "thinks",
      D: "to think",
    },
    correctAnswer: "A",
    explanation:
      "A: 생각하는 B: 생각했다 C: 생각한다 D: 생각하기위해 / 'thinking out of the box'는 '틀에서 벗어나 생각하다'라는 의미의 관용구입니다. 여기서는 'someone thinking'(생각하는 누군가)의 형태로 현재분사가 필요합니다.",
    translation:
      "그녀의 기여는 틀에서 벗어나 생각하면서도 표준과 프로세스를 유지하는 사람의 결과입니다.",
    type: "business email",
  },
  {
    id: 6,
    koreanQuestion:
      "그녀는 확실한 보석이다 가치가 있는 투자할 그리고 _______ 되기에 일부가 장학프로그램 ",
    question:
      "She is a definite gem worth investing in and ______ to be part of the scholarship program.",
    choices: {
      A: "necessary",
      B: "eligible for",
      C: "worthy",
      D: "beneficial",
    },
    correctAnswer: "C",
    explanation:
      "A: 필요한 B: ~에 적격한 C: 자격있는 D: 유익한 / 'worthy'는 '자격있는'이라는 의미로, 장학금 프로그램의 일부가 되기에 자격이 있다는 표현이 문맥상 가장 적절합니다.",
    translation:
      "그녀는 투자할 가치가 있는 확실한 보석이며 장학금 프로그램의 일부가 되기에 자격이 있습니다.",
    type: "business email",
  },
  {
    id: 7,
    koreanQuestion:
      "추가 정보를 위해 그... 당신이 바라는 찾는것을 Martha에 대해 프로그램과 관련하여, 언제든지 연락하십시오. 저에게",
    question:
      "For any additional information you wish to find out about Martha ______ the program, please feel free to contact me.",
    choices: {
      A: "beside",
      B: "across",
      C: "in line with",
      D: "on behalf of",
    },
    correctAnswer: "C",
    explanation:
      "A: (공간적으로) 옆에 B: 가로질러 C: ~에 부합하여, ~에 관하여 D: ~을 대신하여 / 'in line with'는 '~에 부합하여, ~에 관하여'라는 의미로, 마사가 프로그램에 부합한지.",
    translation:
      "당신이 프로그램과 관련하여 Martha에 대해 더 알고 싶은 정보가 있다면, 언제든지 저에게 연락 주세요.",
    type: "business email",
  },
  {
    id: 8,
    koreanQuestion:
      "이번 출장 중에, 저는 (미래에) 만날 예정입니다 주요 파트너들과 그리고 고객들을 마무리하기 위해 계약들을 그리고 논의하기 위해 다가오는 ______ ",
    question:
      "During this trip, I will be meeting with key partners and clients to finalize agreements and discuss upcoming ______.",
    choices: {
      A: "projects",
      B: "project",
      C: "projecting",
      D: "projected",
    },
    correctAnswer: "A",
    explanation:
      "A: 프로젝트들(복수) B: 프로젝트(단수) C: 투영하는 D: 예상된 / 'projects'는 복수형 명사로, 여러 프로젝트에 대해 논의한다는 맥락에 가장 적합합니다.",
    translation:
      "이번 출장 중에 저는 주요 파트너 및 고객과 만나 계약을 마무리하고 다가오는 프로젝트들에 대해 논의할 예정입니다.",
    type: "business email",
  },
  {
    id: 9,
    koreanQuestion:
      "이번 출장 중에 저는 (미래에) 만나고 있을 것입니다 주요 파트너들과 그리고 고객들과 ______ 위해 계약을 그리고 논의하기 위해 다가오는 프로젝트들에 대해.",
    question:
      "During this trip, I will be meeting with key partners and clients to ______ agreements and discuss upcoming projects.",
    choices: {
      A: "finalizing",
      B: "finalize",
      C: "finalized",
      D: "finalization",
    },
    correctAnswer: "B",
    explanation:
      "A: 마무리하는 중(현재분사) B: 마무리하다(원형) C: 마무리된(과거분사) D: 마무리(명사) / 'finalize'는 동사 원형으로, 'to' 부정사 뒤에 오는 동사의 형태로 적절합니다. ",
    translation:
      "이번 출장 중에 저는 주요 파트너 및 고객과 만나 계약을 마무리하고 다가오는 프로젝트들에 대해 논의할 예정입니다.",
    type: "business email",
  },
  {
    id: 10,
    koreanQuestion:
      "주어진 중요성 이 출장, 저는 생각합니다 제 존재가 (미래에) 필수적일 것  ____ 에 있어서  우리의 목표를 , 그리고 저는 확인하고 싶습니다. 그.. 모든 것이 잘 준비되어 있는지 출발전에  ",
    question:
      "Given the importance of this trip, I believe my presence will be essential in ______ our goals, and I would like to ensure that everything is well-prepared before my departure.",
    choices: {
      A: "achieve",
      B: "achieving",
      C: "achieved",
      D: "achievement",
    },
    correctAnswer: "B",
    explanation:
      "A: 달성하다(원형) B: 달성하는 것(동명사) C: 달성된(과거분사) D: 달성(명사) / 전치사 'in' 뒤에는 동명사(~ing) 형태가 와야 합니다. 따라서 'achieving'이 정답입니다.",
    translation:
      "이번 출장의 중요성을 고려할 때, 저는 제 존재가 우리의 목표를 달성하는 데 필수적일 것이라고 생각하며, 출발 전에 모든 것이 잘 준비되어 있는지 확인하고 싶습니다.",
    type: "business email",
  },
  {
    id: 11,
    koreanQuestion:
      "저는 확인할 것입니다 모든 업무가 최신 상태인지 출발하기 전에 , 그리고 저는 (미래에) 연락 가능할 것입니다 원격으로 만약 긴급한 문제가 (현재) ______ 경우 제가 부재중인 동안",
    question:
      "I will make sure all my tasks are up to date before leaving, and I will be available remotely should any urgent matters ______ during my absence.",
    choices: {
      A: "arisen",
      B: "arises",
      C: "arise",
      D: "arising",
    },
    correctAnswer: "C",
    explanation:
      "A: 발생한(과거분사) B: 발생한다(3인칭 단수 현재) C: 발생하다(원형) D: 발생하는(현재분사) → 'should any urgent matters arise'는 '만약 긴급한 문제가 발생할 경우'라는 의미로, should가 if와 같은 조건의 의미로 사용될 때는 항상 동사 원형을 사용합니다. 'arise'는 '발생하다'라는 의미로 긴급한 문제가 생길 가능성을 나타내는 데 적합합니다.",
    translation:
      "저는 출발하기 전에 모든 업무가 최신 상태인지 확인할 것이며, 제가 부재 중일 때 긴급한 문제가 발생할 경우 원격으로 연락 가능할 것입니다.",
    type: "business email",
  },
  {
    id: 12,
    koreanQuestion:
      "저는 또한 계획합니다 ____ 하도록 책임들을 저의 팀에게, 보장하면서 그.. 차질이 없도록 진행 중인 프로젝트에 제가 없는 동안",
    question:
      "I also plan to ______ responsibilities to my team, ensuring that there is no disruption in ongoing projects while I am away.",
    choices: {
      A: "delegation",
      B: "delegated",
      C: "delegate",
      D: "delegating",
    },
    correctAnswer: "C",
    explanation:
      "A: 위임(명사) B: 위임된(과거분사) C: 위임하다(원형) D: 위임하는(현재분사) / 'plan to' 다음에는 동사 원형이 와야 합니다. 'I plan to delegate'는 '나는 위임할 계획이다'라는 의미로, 여기서는 동사 원형인 'delegate'가 올바른 선택입니다.",
    translation:
      "저는 또한 제가 없는 동안 진행 중인 프로젝트에 차질이 없도록 보장하면서, 책임을 제 팀에게 위임할 계획입니다.",
    type: "business email",
  },
  {
    id: 13,
    koreanQuestion:
      "공정 무역 관행은 보장합니다 그... 노동자들이 지불 받도록 공정한 임금을, 지역 사회는 지원되도록, 그리고 환경적 지속 가능성이 ______ 되도록.",
    question:
      "Fair trade practices ensure that workers are paid fair wages, communities are supported, and environmental sustainability is ______.",
    choices: {
      A: "prioritize",
      B: "prioritizing",
      C: "prioritized",
      D: "prioritization",
    },
    correctAnswer: "C",
    explanation:
      "A: 우선시하다(원형) B: 우선시하는(현재분사) C: 우선시되는(과거분사) D: 우선순위화(명사) / 'ensure that workers are paid fair wages, communities are supported, and environmental sustainability is prioritized'에서 'is prioritized'는 수동태 구조로, 과거분사 형태인 'prioritized'가 올바른 선택입니다.",
    translation:
      "공정 무역 관행은 노동자들이 공정한 임금을 받고, 지역 사회가 지원되며, 환경 지속 가능성이 우선시되는 것을 보장합니다.",
    type: "business email",
  },
  {
    id: 14,
    koreanQuestion:
      "우리, 서명한 사람은, 구합니다 당신의 지원을 우리의 요청에 소비자의 권리를 위한 그리고 ______ 무역 관행에 대한.",
    question:
      "We, the undersigned, seek your support in our request for consumer rights and ______ trade practices.",
    choices: {
      A: "fairing",
      B: "fair",
      C: "fairly",
      D: "fairness",
    },
    correctAnswer: "B",
    explanation:
      "A: 공정하게 만드는(의미 없음) B: 공정한(형용사) C: 공정하게(부사) D: 공정함(명사) / 'consumer rights and trade practices'에서 'trade practices'를 수식하는 형용사가 필요하므로 'fair'가 올바른 선택입니다.",
    translation:
      "우리, 서명자들은, 소비자 권리와 공정한 무역 관행에 대한 우리의 요청에 당신의 지원을 구합니다.",
    type: "business email",
  },
  {
    id: 15,
    koreanQuestion:
      "우리는 믿어요 그.. 비즈니스 거래가 반드시  ______ 그리고 진실되어야 한다고, 만들면서 건강한 거래 환경 그.. 이익이 되는 고객들에게, 생산자들에게 그리고 경제 전체에.",
    question:
      "We believe that business transactions should be ______ and truthful, creating a healthy trading environment that benefits consumers, producers and the economy as a whole.",
    choices: {
      A: "equity",
      B: "equitable",
      C: "equitably",
      D: "equal",
    },
    correctAnswer: "B",
    explanation:
      "A: 공정(명사) B: 공정한(형용사) C: 공정하게(부사) D: 동등한(형용사) / 'business transactions should be equitable and truthful'에서 'be' 동사 뒤에 형용사가 필요하므로 'equitable'이 올바른 선택입니다.",
    translation:
      "우리는 비즈니스 거래가 공정하고 진실해야 한다고 믿으며, 소비자, 생산자 및 경제 전체에 이익이 되는 건강한 거래 환경을 조성합니다.",
    type: "business email",
  },
  {
    id: 16,
    koreanQuestion:
      "마케팅 부서는 _____ 브로셔 초안을 내일 그리고 배포할 것이다 그 초안을 영업팀에 다음주에.",
    question:
      "The marketing department ______ the brochure draft tomorrow and then distribute it to the sales team next week.",
    choices: {
      A: "finalized",
      B: "finalizing",
      C: "had finalized",
      D: "will finalize",
    },
    correctAnswer: "D",
    explanation:
      "A: 마무리했다(과거) B: 마무리하는(현재분사) C: 마무리했었다(과거완료) D: 마무리할 것이다(미래) / 내일 일어날 일을 표현하고 있으므로 미래 시제인 'will finalize'가 올바른 선택입니다.",
    translation:
      "마케팅 부서는 내일 브로셔 초안을 마무리하고 다음 주에 영업팀에 배포할 것입니다.",
    type: "business email",
  },
  {
    id: 17,
    koreanQuestion:
      "모든 직원들은 (현재) 완료했다 고급 교육을 그리고 따라서 _____ 접근할 보안 데이터베이스에.",
    question:
      "All staff have completed the advanced training and are therefore _____ to access the secure database.",
    choices: {
      A: "qualify",
      B: "qualifying",
      C: "qualifies",
      D: "qualified",
    },
    correctAnswer: "D",
    explanation:
      "A: 자격을 갖추다(동사 원형) B: 자격을 갖추는(현재분사) C: 자격을 갖춘다(3인칭 단수) D: 자격을 갖춘(과거분사) / 'be qualified to do'는 '~할 자격이 있다'라는 의미로, 수동의 의미를 가진 과거분사 형태인 'qualified'가 올바른 선택입니다.",
    translation:
      "모든 직원들은 고급 교육을 완료했으며 따라서 보안 데이터베이스에 접근할 자격이 있습니다.",
    type: "business email",
  },
  {
    id: 18,
    koreanQuestion:
      "프로토타입은 (현재) 통과했다 모든 안전 테스트를 그리고 이제 _______ 상업 생산을 위해.",
    question:
      "The prototype has passed all safety tests and is now ______ for commercial production.",
    choices: {
      A: "approve",
      B: "approving",
      C: "approves",
      D: "approved",
    },
    correctAnswer: "D",
    explanation:
      "A: 승인하다(동사 원형) B: 승인하는(현재분사) C: 승인한다(3인칭 단수) D: 승인된(과거분사) / 'is approved'는 수동태로, 프로토타입이 승인을 받은 상태를 나타내므로 과거분사 형태인 'approved'가 올바른 선택입니다.",
    translation:
      "프로토타입은 모든 안전 테스트를 통과했으며 이제 상업 생산을 위해 승인되었습니다.",
    type: "business email",
  },
  {
    id: 19,
    koreanQuestion:
      "이 명망 있는 행사는 목표로 한다 데리고 오기 위해 저명한 손님들을 한자리에 지원하기 위해 고귀한 목적을 그리고 ____ 영향을 미치게 하기 위해 우리 지역사회에.",
    question:
      "This prestigious event aims to bring distinguished guests together to support a noble cause and ______ impact our community.",
    choices: {
      A: "significantly",
      B: "significant",
      C: "significance",
      D: "signification",
    },
    correctAnswer: "A",
    explanation:
      "A: 상당히(부사) B: 중요한(형용사) C: 중요성(명사) D: 의미(명사, 잘 사용되지 않음) / 'impact'는 동사로 사용될 때 '영향을 미치다'라는 의미를 가지며, 이를 수식하는 부사 'significantly'가 올바른 선택입니다.",
    translation:
      "이 명망 있는 행사는 고귀한 목적을 지원하기 위해 저명한 손님들을 한자리에 모으고 우리 지역사회에 상당한 영향을 미치는 것을 목표로 합니다.",
    type: "business email",
  },
  {
    id: 20,
    koreanQuestion:
      "이 모금 캠페인은 시작되었습니다 지원하기 위해 중요한 ______ 를 그...혜택을 주는 소외된 아이들에게.",
    question:
      "This fundraising campaign was launched to support an important ______ that benefits underprivileged children.",
    choices: {
      A: "caused",
      B: "causing",
      C: "cause",
      D: "causes",
    },
    correctAnswer: "C",
    explanation:
      "A: 야기된(과거분사) B: 야기하는(현재분사) C: 대의, 명분(명사) D: 대의, 명분들(복수 명사) / 'an important cause'에서 'cause'는 '대의, 명분'을 의미하는 단수 명사가 필요하므로 C가 올바른 선택입니다.",
    translation:
      "이 모금 캠페인은 소외된 아이들에게 혜택을 주는 중요한 대의를 지원하기 위해 시작되었습니다.",
    type: "business email",
  },
  {
    id: 21,
    koreanQuestion:
      "우리는 (현재) 준비했습니다 특별한 프로그램을 보장하기 위해 우리 손님들이  ______ 잊을 수 없는 경험을 기여하면서 가치 있는 대의에.",
    question:
      "We have curated an exceptional program to ensure our guests ______ an unforgettable experience while contributing to a worthy cause.",
    choices: {
      A: "has",
      B: "having",
      C: "have",
      D: "had been",
    },
    correctAnswer: "C",
    explanation:
      "A: has(3인칭 단수 현재형) B: having(현재분사) C: have(복수 현재형) D: had been(과거완료진행형) / 'our guests'는 복수 주어이므로 복수형 동사 'have'가 필요합니다.",
    translation:
      "우리는 손님들이 가치 있는 대의에 기여하면서 잊을 수 없는 경험을 할 수 있도록 특별한 프로그램을 준비했습니다.",
    type: "business email",
  },
  {
    id: 22,
    koreanQuestion:
      "알려주십시오 당신이 어떤 _____ 제한 사항들이 있다면, 예를 들어 알러지들 견과류, 유제품, 또는 글루텐에 대한.",
    question:
      "Please let us know if you have any ______ restrictions, such as allergies to nuts, dairy, or gluten.",
    choices: {
      A: "financial",
      B: "physical",
      C: "dietary",
      D: "regional",
    },
    correctAnswer: "C",
    explanation:
      "A: 재정적인 B: 신체적인 C: 식이 관련된 D: 지역적인 / 문맥상 '견과류, 유제품, 글루텐에 대한 알레르기'는 식이 제한사항(dietary restrictions)에 해당하므로 C가 정답입니다.",
    translation:
      "견과류, 유제품 또는 글루텐에 대한 알레르기와 같은 식이 제한사항이 있으시면 알려주십시오.",
    type: "business email",
  },
  {
    id: 23,
    koreanQuestion:
      "팀은 조정했습니다 _____ 충족하기 위해 고객의 새로운 사양을",
    question:
      "The team adjusted ______ to meet the client's new specifications.",
    choices: {
      A: "precise",
      B: "precisely",
      C: "precision",
      D: "precising",
    },
    correctAnswer: "B",
    explanation:
      "A: precise(정확한, 형용사) B: precisely(정확하게, 부사) C: precision(정밀함, 명사) D: precising(존재하지 않는 단어) / 동사 'adjusted'를 수식하려면 부사 'precisely'가 필요합니다.",
    translation:
      "팀은 고객의 새로운 사양을 충족하기 위해 정확하게 조정했습니다.",
    type: "business email",
  },
  {
    id: 24,
    koreanQuestion:
      "도착해 주십시오. 최소 30분에 시작 시간전에 등록과 체크인을 위해 ",
    question:
      "Please arrive at least 30 minutes ______ the start time for registration and check-in.",
    choices: {
      A: "on",
      B: "by",
      C: "at",
      D: "before",
    },
    correctAnswer: "D",
    explanation:
      "A: ~에 (특정 날짜/요일) B: ~까지 (기한) C: ~에 (특정 시간/장소) D: ~전에 (시간/장소 앞에)",
    translation:
      "등록 및 체크인을 위해 시작 시간보다 최소 30분 전에 도착해 주십시오.",
    type: "business email",
  },
  {
    id: 25,
    koreanQuestion:
      "친절히 확인해 주십시오 당신이 ______ 모든 필요한 여행 및 숙박 준비를 미리.",
    question:
      "Kindly ensure that you ______ all necessary travel and accommodation arrangements in advance.",
    choices: {
      A: "make",
      B: "have made",
      C: "are making",
      D: "had made",
    },
    correctAnswer: "B",
    explanation:
      "A: make(현재형, 만들다) B: have made(현재완료형 - 현재 만들었다) C: are making(현재진행형 - 현재 만드는 중) D: had made(과거완료형 - 과거에 만들었다) / 미리 준비를 '해놓았는지' 확인하는 것이므로 현재완료형이 적절합니다.",
    translation:
      "친절히 모든 필요한 여행 및 숙박 준비를 미리 해놓았는지 확인해 주십시오.",
    type: "business email",
  },
  {
    id: 26,
    koreanQuestion:
      "편의를 위해, 한 목록이  ______ 호텔 및 교통 옵션 포함되있습니다 첨부 문서에",
    question:
      "For your convenience, a list of ______ hotels and transportation options is included in the attached document.",
    choices: {
      A: "nearly",
      B: "near",
      C: "nearby",
      D: "nearing",
    },
    correctAnswer: "C",
    explanation:
      "A: nearly (거의) B: near (~에 가까운, 전치사) C: nearby (가까운 곳에 있는, 형용사) D: nearing (다가오는, 접근하는)",
    translation:
      "편의를 위해 근처 호텔 및 교통 옵션 목록이 첨부 문서에 포함되어 있습니다.",
    type: "business email",
  },
  {
    id: 27,
    koreanQuestion:
      "귀하의 참석 그리고 기여는 의심할 여지없이 더할 것입니다 가치를 ______에 그리고 결과에 회의.",
    question:
      "Your presence and contributions will undoubtedly add value to the ______ and outcomes of the conference.",
    choices: {
      A: "decorations",
      B: "distractions",
      C: "discussions",
      D: "donations",
    },
    correctAnswer: "C",
    explanation:
      "A: decorations(장식) B: distractions(방해, 주의산만) C: discussions(토론, 논의) D: donations(기부, 기증) .",
    translation:
      "귀하의 참석과 기여는 의심할 여지없이 회의의 토론 및 결과에 가치를 더할 것입니다.",
    type: "business email",
  },
  {
    id: 28,
    koreanQuestion:
      "귀하의 ____한 지원과 함께 과거에, 우리는 (현재) 시작할 수 있었다 방과후 프로그램을 그.. 제공하는 200명에게 우리 지역 내에서 ",
    question:
      "With your ______ support in the past, we have been able to launch after-school programs that serve over 200 children in our local area.",
    choices: {
      A: "gentle",
      B: "financials",
      C: "generous",
      D: "generosity",
    },
    correctAnswer: "C",
    explanation:
      "A: gentle (부드러운) B: financials (재무제표, 재정자료) C: generous (관대한, 후한) D: generosity (관대함, 너그러움, 명사)",
    translation:
      "과거의 귀하의 관대한 지원 덕분에, 우리는 지역 내 200명 이상의 아이들에게 방과 후 프로그램을 시작할 수 있었습니다.",
    type: "business email",
  },
  {
    id: 29,
    koreanQuestion:
      "그러나 우리의 여정은 아직 멀었고, 우리의 영향력을 확장할 수 있도록 귀하의 지속적인 파트너십이 필요합니다.",
    question:
      "However, our journey is far ______ over, and we need your continued partnership to ensure we can expand our impact.",
    choices: {
      A: "by",
      B: "with",
      C: "from",
      D: "through",
    },
    correctAnswer: "C",
    explanation:
      "A: by (전치사) B: with (전치사) C: from (전치사) D: through (전치사). 'far from over'는 '끝나기는커녕 아직 멀었다'라는 의미의 관용 표현입니다. 이런 표현은 자주 보면서 암기하는 것이 좋습니다.",
    translation:
      "그러나 우리의 여정은 아직 끝에서 멀고, 우리의 영향력을 확장할 수 있도록 귀하의 지속적인 파트너십이 필요합니다.",
    type: "business email",
  },
  {
    id: 30,
    koreanQuestion:
      "감사합니다  귀하의 ____한 지원 그리고 헌신 우리의 대의에 대한.",
    question: "Thank you for your ______ support and dedication to our cause.",
    choices: {
      A: "waving",
      B: "unworthy",
      C: "unwavering",
      D: "wavingly",
    },
    correctAnswer: "C",
    explanation:
      "A: waving (흔드는) B: unworthy (가치 없는) C: unwavering (흔들림 없는, 확고한) D: wavingly (흔들리게, 부사형으로 문법적으로 맞지 않음)",
    translation: "귀하의 확고한 지원과 우리의 대의에 대한 헌신에 감사드립니다.",
    type: "business email",
  },
  {
    id: 31,
    koreanQuestion:
      "그녀는  ______ 역할을 했습니다. 여러 중요 프로젝트에서, 예를들어 출시 새로운 CRM 시스템 그리고 전면개편 우리의 내부 커뮤니케이션 플랫폼 ",
    question:
      "She played a ______ role in several critical projects, such as the launch of our new CRM system and the overhaul of our internal communications platform.",
    choices: {
      A: "pivotal",
      B: "pleasant",
      C: "physical",
      D: "portable",
    },
    correctAnswer: "A",
    explanation:
      "A: pivotal (중추적인, 핵심적인) B: pleasant (즐거운, 유쾌한) C: physical (물리적인, 신체적인) D: portable (휴대용의, 이동식의)",
    translation:
      "그녀는 우리의 새로운 CRM 시스템 출시와 내부 커뮤니케이션 플랫폼 개편과 같은 여러 중요한 프로젝트에서 중추적인 역할을 했습니다.",
    type: "business email",
  },
  {
    id: 32,
    koreanQuestion:
      "요약하자면, Johann Harvey는 매우 숙련되고, 의욕적이며, 그리고 적극적인 개인으로 그.. ___ 한 추가가 될 것입니다 BlueLeaf에 ",
    question:
      "In summary, Johann Harvey is a highly skilled, motivated, and proactive individual who would be an ______ addition to BlueLeaf.",
    choices: {
      A: "invaluable",
      B: "invalid",
      C: "invariable",
      D: "invisible",
    },
    correctAnswer: "A",
    explanation:
      "A: invaluable (매우 귀중한, 값을 매길 수 없는) B: invalid (유효하지 않은, 무효한) C: invariable (변하지 않는, 일정한) D: invisible (보이지 않는, 눈에 띄지 않는)",
    translation:
      "요약하자면, Johann Harvey는 매우 숙련되고, 의욕적이며, 적극적인 개인으로 BlueLeaf에 매우 귀중한 추가가 될 것입니다.",
    type: "business email",
  },
  {
    id: 33,
    koreanQuestion:
      " ______ 그녀의 분석적 강점, Maria는 가진다 탁월한 능력을 협력하는 다양한 팀과 , 관리하는 프로젝트 마감일들을, 그리고 유지하는 긍정적 태도를 심각한 압박속에서도",
    question:
      "______ her analytical strengths, Maria has an exceptional ability to collaborate with diverse teams, manage project deadlines, and maintain a positive attitude even under significant pressure.",
    choices: {
      A: "Against",
      B: "Without",
      C: "Beyond",
      D: "Beneath",
    },
    correctAnswer: "C",
    explanation:
      "A: Against (〜에 반하여) B: Without (〜없이) C: Beyond (〜을 넘어서, 〜외에도) D: Beneath (〜아래에)",
    translation:
      "분석적 강점 외에도, Maria는 다양한 팀과 협력하고, 프로젝트 마감일을 관리하며, 상당한 압박 속에서도 긍정적인 태도를 유지하는 탁월한 능력을 가지고 있습니다.",
    type: "business email",
  },
  {
    id: 34,
    koreanQuestion:
      "저는 (현재) 알았습니다 Charley Stokes를 6년이상 동안 전문적인 ______ 뿐만 아니라 개인적인 수준에서도.",
    question:
      "I have known Charley Stokes for over six years in a professional ______ as well as on a personal level.",
    choices: {
      A: "capability",
      B: "captivity",
      C: "capacity",
      D: "casualty",
    },
    correctAnswer: "C",
    explanation:
      "A: capability (능력, 역량) B: captivity (포로 상태, 감금) C: capacity (역할, 자격, 용량) D: casualty (사상자, 피해자)",
    translation:
      "저는 Charley Stokes를 전문적인 역할로서 뿐만 아니라 개인적인 수준에서도 6년 이상 알고 있습니다.",
    type: "business email",
  },
  {
    id: 35,
    koreanQuestion:
      "그의 전문성과 진실성은 ______ 칭찬할 만하며, 그리고 그는 일관적으로 보여줍니다 신뢰성을 모든 영역에서 그의 업무 그리고 개인적 약속.",
    question:
      "His professionalism and integrity ______ commendable, and he consistently demonstrates reliability in all areas of his work and personal commitments.",
    choices: {
      A: "is",
      B: "are",
      C: "was",
      D: "has been",
    },
    correctAnswer: "B",
    explanation:
      "A: is (단수 동사) B: are (복수 동사) C: was (과거 단수 동사) D: has been (현재완료 단수 동사) - 'His professionalism and integrity'는 두 개의 명사가 'and'로 연결된 복수 주어이므로 복수 동사 'are'가 올바른 선택입니다.",
    translation:
      "그의 전문성과 진실성은 칭찬할 만하며, 그는 업무와 개인적인 약속의 모든 영역에서 일관되게 신뢰성을 보여줍니다.",
    type: "business email",
  },
  {
    id: 36,
    koreanQuestion:
      "저는 특히 끌렸습니다 이 기회에 LifeWhiz에서의 이것이 _____ 때문에 저의 열정과 통합하는 지속가능한 관행들을 프로젝트 관리에 ",
    question:
      "I am particularly drawn to this opportunity at LifeWhiz as it ______ with my passion for integrating sustainable practices into project management.",
    choices: {
      A: "allows",
      B: "agrees",
      C: "aligns",
      D: "attaches",
    },
    correctAnswer: "C",
    explanation:
      "A: allows (허용하다) B: agrees (동의하다) C: aligns (일치하다, 부합하다) D: attaches (부착하다) - 'align with'는 '~와 일치하다, 부합하다'라는 의미로, 가치, 목표, 관심사 등이 잘 맞는다는 표현입니다.",
    translation:
      "저는 LifeWhiz에서의 이 기회에 특히 관심이 있습니다. 왜냐하면 이것이 프로젝트 관리에 지속 가능한 관행을 통합하는 저의 열정과 일치하기 때문입니다.",
    type: "business email",
  },
  {
    id: 37,
    koreanQuestion:
      "귀하의 기술과 경험은 일치합니다 완벽하게 우리팀의 ____ 와, 그리고 우리는 기대하고 있습니다 기여들을 그.. 당신이 만들것인 우리의 조직에",
    question:
      "Your skills and experience align perfectly with our team's ______, and we are excited about the contributions you will make to our organization.",
    choices: {
      A: "needy",
      B: "needing",
      C: "needs",
      D: "needful",
    },
    correctAnswer: "C",
    explanation:
      "A: needy (궁핍한, 가난한) B: needing (필요로 하는) C: needs (필요, 명사) D: needful (필요한, 유용한) - 'align with our team's needs'에서 'needs'는 명사 형태로 '필요(들)'을 의미합니다. 따라서 C가 정답입니다.",
    translation:
      "귀하의 기술과 경험은 우리 팀의 필요와 완벽하게 일치하며, 우리는 귀하가 우리 조직에 기여할 것에 대해 기대하고 있습니다.",
    type: "business email",
  },
  {
    id: 38,
    koreanQuestion:
      "귀하의 ______ 는 $95,000일 것이다 연간, 추가 혜택과 함께 그...포함합니다 건강 보험, 401(k) 퇴직 계획 회사 매칭과 함께, 그리고 유급 휴가를",
    question:
      "Your ______ will be $95,000 per year, with additional benefits that include health insurance, a 401(k) retirement plan with company matching, and paid time off.",
    choices: {
      A: "donation",
      B: "occupation",
      C: "compensation",
      D: "contribution",
    },
    correctAnswer: "C",
    explanation:
      "A: donation (기부) B: occupation (직업) C: compensation (보상, 급여) D: contribution (기여) - 'compensation'은 직장에서 받는 급여와 혜택을 의미합니다. 문맥상 연봉과 추가 혜택에 대해 설명하고 있으므로 C가 정답입니다.",
    translation:
      "귀하의 보상(급여)은 연간 $95,000이며, 건강 보험, 회사 매칭이 있는 401(k) 퇴직 계획 및 유급 휴가를 포함한 추가 혜택이 제공됩니다.",
    type: "business email",
  },
  {
    id: 39,
    koreanQuestion:
      "티켓에 따르면, 저는 ______ 되었습니다 주차한것으로 제한 구역에 ",
    question:
      "According to the ticket, I was ______ for being parked in a restricted area.",
    choices: {
      A: "cited",
      B: "signed",
      C: "claimed",
      D: "pointed",
    },
    correctAnswer: "A",
    explanation:
      "A: cited (인용된, 소환된) B: signed (서명된) C: claimed (주장된) D: pointed (지적된) - 'cited'는 법적 위반에 대해 '소환장을 받다'라는 의미로 사용됩니다. 제한 구역에 주차했다는 이유로 소환장(티켓)을 받았으므로 A가 정답입니다.",
    translation:
      "티켓에 따르면, 저는 제한 구역에 주차했다는 이유로 소환장을 받았습니다.",
    type: "business email",
  },
  {
    id: 40,
    koreanQuestion:
      "오랜 고객으로서,저는 (현재) 기대했다 일정 수준의 전문성 그리고 품질을 너의 회사와 , 하지만 나의 최근의 경험은 (현재) 두었습니다 저를  ______ 실망한 상태로",
    question:
      "As a long-time customer, I have come to expect a certain level of professionalism and quality from your company, but my recent experience has left me ______ disappointed.",
    choices: {
      A: "lately",
      B: "highly",
      C: "mostly",
      D: "deeply",
    },
    correctAnswer: "D",
    explanation:
      "A: lately (최근에) B: highly (매우, 대단히) C: mostly (대부분, 주로) D: deeply (깊이, 심하게) - 'deeply'는 감정의 깊이를 나타내는 부사로, '깊이 실망했다'는 표현이 가장 적절합니다. 문맥상 고객의 강한 실망감을 표현하므로 D가 정답입니다.",
    translation:
      "오랜 고객으로서, 저는 귀사로부터 일정 수준의 전문성과 품질을 기대해 왔지만, 최근의 경험은 저를 깊이 실망시켰습니다.",
    type: "business email",
  },
  {
    id: 41,
    koreanQuestion:
      "친절히 ____ 해주세요 이 문제를 심각하게 이것이 가져올 수 있기 때문에 바람직하지 않은 결과를 다른 사람들에게 그... 제품을 사용할지도 모르는",
    question:
      "Kindly ______ this issue seriously as it could bring about undesirable consequences for others who might use the product.",
    choices: {
      A: "engage",
      B: "grant",
      C: "gauge",
      D: "guard",
    },
    correctAnswer: "C",
    explanation:
      "A: engage (참여하다, 관여하다) B: grant (허가하다, 부여하다) C: gauge (평가하다, 측정하다) D: guard (지키다, 보호하다) - 'gauge'는 '평가하다'라는 의미로, 문제의 심각성을 평가하는 맥락에서 가장 적절합니다. 따라서 C가 정답입니다.",
    translation:
      "이 문제를 심각하게 평가해 주시기 바랍니다. 제품을 사용할 수 있는 다른 사람들에게 바람직하지 않은 결과를 초래할 수 있습니다.",
    type: "business email",
  },
  {
    id: 42,
    koreanQuestion:
      "감사의 ______ 로, 모든 기부자와 후원자는 받을 것입니다 인정을 우리의 행사 프로그램과 온라인 플랫폼에서 ",
    question:
      "As a ______ of appreciation, all donors and sponsors will receive recognition in our event program and online platforms.",
    choices: {
      A: "title",
      B: "symbol",
      C: "token",
      D: "mark",
    },
    correctAnswer: "C",
    explanation:
      "A: title (제목, 직함) B: symbol (상징, 기호) C: token (표시, 증거, 징표) D: mark (표시, 흔적) - 'token of appreciation'은 '감사의 표시'라는 의미로 자주 사용되는 관용 표현입니다. 따라서 C가 정답입니다.",
    translation:
      "감사의 표시로, 모든 기부자와 후원자는 우리의 행사 프로그램과 온라인 플랫폼에서 인정을 받을 것입니다.",
    type: "business email",
  },
  {
    id: 43,
    koreanQuestion:
      "함께, 우리는 강화할 수 있습니다 우리의 커뮤니티를 그리고 만들 수 있습니다 ______ 긍정적인 변화를",
    question:
      "Together, we can strengthen our community and create ______ positive change.",
    choices: {
      A: "lasting",
      B: "late",
      C: "latest",
      D: "lastingly",
    },
    correctAnswer: "A",
    explanation:
      "A: lasting (지속적인, 오래가는) B: late (늦은) C: latest (최신의, 최근의) D: lastingly (지속적으로) - 'lasting positive change'는 '지속적인 긍정적 변화'를 의미하며, 문맥상 가장 적절합니다. 따라서 A가 정답입니다.",
    translation:
      "함께, 우리는 우리의 커뮤니티를 강화하고 지속적인 긍정적인 변화를 만들 수 있습니다.",
    type: "business email",
  },
  {
    id: 44,
    koreanQuestion:
      "확인하기 위해 당신이 수락을 이 제안, 완료해 주세요 필요한 등록 절차들을 ______ 수락 패킷안에.",
    question:
      "To confirm your acceptance of this offer, please complete the necessary enrollment procedures ______ in your acceptance packet.",
    choices: {
      A: "inserted",
      B: "involved",
      C: "outlined",
      D: "influenced",
    },
    correctAnswer: "C",
    explanation:
      "A: inserted (삽입된) B: involved (관련된) C: outlined (개요가 설명된, 요약된) D: influenced (영향을 받은) - 'outlined'는 '개요가 설명된, 요약된'이라는 의미로, 수락 패킷에 등록 절차가 요약되어 있다는 맥락에 가장 적합합니다. 따라서 C가 정답입니다.",
    translation:
      "이 제안을 수락하셨음을 확인하기 위해, 수락 패킷에 요약된 필요한 등록 절차를 완료해 주십시오.",
    type: "business email",
  },
  {
    id: 45,
    koreanQuestion:
      "고객 서비스 담당자는 _____한 유지했습니다 수십 명의 발신자가 불만을 제기했을 때 시스템 장애에 대해.",
    question:
      "The customer service agent remained _____ even when dozens of callers complained about the system outage.",
    choices: {
      A: "irritated",
      B: "courteous",
      C: "dismissive",
      D: "perplexed",
    },
    correctAnswer: "B",
    explanation:
      "A: irritated (짜증난) B: courteous (공손한, 예의 바른) C: dismissive (무시하는) D: perplexed (당혹스러운, 혼란스러운) - 고객 서비스 담당자가 많은 불만 전화에도 '공손함'을 유지했다는 것이 가장 적절합니다. 따라서 B가 정답입니다.",
    translation:
      "고객 서비스 담당자는 수십 명의 발신자가 시스템 장애에 대해 불만을 제기했을 때도 공손한 상태를 유지했습니다.",
    type: "business email",
  },
  {
    id: 46,
    koreanQuestion:
      "목적은 이 서신 ____ 위해서 수령을 그리고 수락을 해지 통지 그... 당신이 전달한 지난주에 .",
    question:
      "The purpose of this correspondence is to ______ receipt and acceptance of the termination notification you forwarded in the preceding week.",
    choices: {
      A: "notify",
      B: "remind",
      C: "express",
      D: "confirm",
    },
    correctAnswer: "D",
    explanation:
      "A: notify (알리다, 통지하다) B: remind (상기시키다) C: express (표현하다) D: confirm (확인하다) - '확인하다(confirm)'는 수령과 수락을 인정한다는 의미로 가장 적합합니다. 따라서 D가 정답입니다.",
    translation:
      "이 서신의 목적은 지난 주에 귀하가 전달한 해지 통지의 수령 및 수락을 확인하기 위함입니다.",
    type: "business email",
  },
  {
    id: 47,
    koreanQuestion:
      "갑작스러운 성격 이 결과 불구하고, 저는 감사하고 있습니다 기회들 그리고 경험들 그... 제공된 재임기간동안에 ",
    question:
      "______ the sudden nature of this outcome, I remain appreciative of the opportunities and experiences offered during the tenure of my role.",
    choices: {
      A: "Despite",
      B: "Because",
      C: "However",
      D: "Although",
    },
    correctAnswer: "A",
    explanation:
      "A: Despite (~에도 불구하고) - 문장 앞에서 대조적인 상황을 나타내는 전치사로 적합합니다. B: Because (~때문에) - 원인을 나타내므로 문맥상 맞지 않습니다. C: However (그러나) - 접속부사로 문장 사이에 사용되어야 하므로 부적합합니다. D: Although (비록 ~일지라도) - 접속사로 완전한 절이 뒤따라야 하는데, 여기서는 명사구만 있어 문법적으로 맞지 않습니다. 따라서 A가 정답입니다.",
    translation:
      "이 결과의 갑작스러운 성격에도 불구하고, 저는 제 역할 재임 기간 동안 제공된 기회와 경험에 감사하고 있습니다.",
    type: "business email",
  },
  {
    id: 48,
    koreanQuestion:
      "저는 진심으로 영광스럽고 감사합니다 선발된 것에 이 장학금을 위해,  그.. 상당히 도와줄 저의 교육 여정을.",
    question:
      "I am truly honored and grateful to ______ selected for this scholarship, which will significantly support my educational journey.",
    choices: {
      A: "be",
      B: "have been",
      C: "being",
      D: "had been",
    },
    correctAnswer: "A",
    explanation:
      "A: be (선발되다) - 수동태 현재형으로 적절합니다. B: have been (선발되어 왔다) - 현재완료 수동태로 시제가 맞지 않습니다. C: being (선발되는 중인) - 동명사 형태로 문맥에 맞지 않습니다. D: had been (선발되었었다) - 과거완료 수동태로 시제가 맞지 않습니다. 따라서 A가 정답입니다.",
    translation:
      "저는 이 장학금에 선발된 것에 진심으로 영광스럽고 감사합니다. 이는 제 교육 여정에 상당한 도움이 될 것입니다.",
    type: "business email",
  },
  {
    id: 49,
    koreanQuestion:
      "이 장학금은 해줄 것입니다 제가 집중하도록 더 학업에 그리고 덜 재정적 ___에 학업 비용 그리고 관련된 소비들.",
    question:
      "This scholarship will allow me to focus more on my studies and less on the financial ______ of tuition fees and related expenses.",
    choices: {
      A: "pressure",
      B: "responsibility",
      C: "duty",
      D: "burden",
    },
    correctAnswer: "D",
    explanation:
      "A: pressure (압박, 압력) - 일반적인 압박감을 의미합니다. B: responsibility (책임) - 의무적인 책임을 의미합니다. C: duty (의무) - 해야 할 의무를 의미합니다. D: burden (부담) - 재정적 어려움이나 짐을 의미하는 단어로, 학비와 관련 비용에 대한 재정적 어려움을 가장 적절하게 표현합니다. 따라서 D가 정답입니다.",
    translation:
      "이 장학금은 제가 학비와 관련 비용의 재정적 부담보다는 학업에 더 집중할 수 있게 해줄 것입니다.",
    type: "business email",
  },
  {
    id: 50,
    koreanQuestion:
      "예산 제약으로 인해, 이사회는 (현재) 결정했습니다 ______ 추가 자금을 새로운 프로젝트를 위해 다음 회계연도에.",
    question:
      "Due to budget constraints, the board has decided to ______ additional funding for new projects next fiscal year.",
    choices: {
      A: "alleviate",
      B: "allocate",
      C: "elevate",
      D: "elaborate",
    },
    correctAnswer: "B",
    explanation:
      "A: alleviate (완화하다) - 고통이나 문제를 줄이는 것을 의미하므로 맥락에 맞지 않습니다. B: allocate (할당하다) - 특정 목적을 위해 자원을 배분하는 것을 의미하므로 가장 적합합니다. C: elevate (높이다) - 무언가의 수준이나 위치를 높이는 것을 의미하므로 맥락에 맞지 않습니다. D: elaborate (정교하게 하다) - 세부 사항을 추가하거나 자세히 설명하는 것을 의미하므로 맥락에 맞지 않습니다. 따라서 B가 정답입니다.",
    translation:
      "예산 제약으로 인해, 이사회는 다음 회계연도에 새로운 프로젝트를 위한 추가 자금을 할당하기로 결정했습니다.",
    type: "business email",
  },
];
